import axios from 'axios';
import { Dialog } from 'react-weui-ts';
import { getUrlParam } from '../../utils/helpers';
import { base_url } from '../../config';

interface DeleteDialogProps {
    show: boolean;
    close: () => void;
    clearStaves: () => void;
}

const DeleteDialog = ({ show, close, clearStaves }: DeleteDialogProps) => {
    const deleteIcon = require('../../assets/icons/information-fill.png');

    return (
        <Dialog
            type="ios"
            title={'删除'}
            buttons={[
                {
                    label: '取消',
                    onClick: () => {
                        console.log('取消');
                        close();
                    },
                    style: {
                        color: '#666',
                        background: '#F7F7F7',
                        borderRadius: '10px',
                        margin: '10px 15px 10px 15px',
                    },
                },
                {
                    label: '确定',
                    onClick: () => {
                        const id: string | null = getUrlParam('id');
                        const openid: string | null = getUrlParam('openid');

                        axios
                            .post(`${base_url}/staff-destroy`, {
                                id,
                                openid: openid,
                            })
                            .then((res: any) => {
                                console.log(res);
                                clearStaves();
                                window.location.href = '/?openid=' + openid;
                            })
                            .finally(() => {
                                close();
                            })
                            .catch((e) => {
                                console.log('删除乐谱失败', e);
                                alert('删除乐谱失败, 请稍后重试!');
                            });
                    },
                    style: {
                        color: '#fff',
                        background: '#DFAE4B',
                        borderLeft: 'none',
                        borderRadius: '10px',
                        margin: '10px 15px 10px 15px',
                    },
                },
            ]}
            show={show}
        >
            <div className="delete-content">
                <img src={deleteIcon} width={24} height={24} alt="" />
                <span>你确认删除吗？</span>
            </div>
        </Dialog>
    );
};

export default DeleteDialog;
